import React from 'react';
import Input from './Input';

const AuthInput = ({ icon, type = 'text', placeholder, value, onChange, name }) => (
  <div style={{ position: 'relative' }}>
    <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#8c8c8c' }}>{icon}</span>
    <Input
      name={name}
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      style={{ width: '100%', paddingLeft: 36 }}
      autoComplete={type === 'password' ? 'new-password' : 'email'}
    />
  </div>
);

export default AuthInput;



